import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useRouteMatch } from 'react-router-dom';
import cn from 'classnames';

import { feSetStylistId, feSidebarClose } from 'actions/ui.actions';
import ICON_HEADER from 'assets/images/icons/calendar-purple-light.svg';
import ExternalLink from 'components/generic/ExternalLink.component';
import { TaxesBanner } from 'components/generic/TaxesBanner.component';
import LINK from 'constants/link.const';
import S from 'constants/string.const';
import { useHelpLinks } from 'hooks/useHelpLinks.hook';
import useIsFromMobileApp from 'hooks/useIsFromMobileApp.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import { formatSegmentWeek } from 'utils/date/format.util';
import { nowAsTimestamp } from 'utils/date/now.util';
import linkToCalendar from 'utils/links/linkToCalendar';

import PadLock from 'lib/components/PadLock';

import CN from './TopNav.module.scss';

const TopNav = ({ title, children }) => {
  const salonId = useCurrentSalonId();
  const { isDarkMode } = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { baseHelpLink } = useHelpLinks();

  const isFromMobile = useIsFromMobileApp();

  const componentClasses = cn({
    [CN.component]: true,
    [CN.dark]: isDarkMode,
  });

  const linkCalendar = linkToCalendar({ salonId, week: formatSegmentWeek(nowAsTimestamp()) }) || S.hash;

  const handleCalendarClick = useCallback(() => {
    dispatch(feSetStylistId(null));
    dispatch(feSidebarClose({ tag: 'TopNav.handleCalendarClick()' }));
  }, [dispatch]);

  const isServicesPage = useRouteMatch({ path: LINK.services, exact: true });

  return (
    <div className={componentClasses}>
      {isServicesPage && <TaxesBanner location="services" />}
      <div className={CN.headerContainer}>
        <div className={CN.header}>
          {children}
          <div className={CN.title}>{title}</div>
        </div>

        <div className={CN.controls}>
          {!isFromMobile && (
            <>
              <div className={CN.control}>
                <ExternalLink link={baseHelpLink} variant="inline">
                  <div className={CN.helpIcon}>{t('common.help')}</div>
                </ExternalLink>
              </div>

              <div className={cn([CN.control], [CN.background])}>
                <NavLink to={linkCalendar} onClick={handleCalendarClick} className={CN.calendarLink}>
                  <img src={ICON_HEADER} alt="" className={CN.calendarIcon} />
                </NavLink>
              </div>
            </>
          )}
          <div className={CN.control}>
            <PadLock />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
